<template>
    <div ref="topbarheight" class="jom-topbar">
        <el-container>
            <el-main>
                <div>
                  <h1 v-for="item in titlegroup.articletitle" v-if="item.lang == lang" class="topbar_title">
                    <component :is="'jo' + item2.name" v-for="item2 in item.data" v-bind:key="item2.index" v-bind:data="item2.data"></component>
                  </h1>
                  <h1 v-if="titlegroup.articletitle.length==0">{{lang=='en'? 'None' : '无'}}</h1>
                  <h1 v-else-if="titlegroup.articletitle.length==1 && titlegroup.articletitle[0].lang !== lang">{{lang=='en'? 'None' : '无'}}</h1>
                  <h2 v-for="item in titlegroup.subtitle" v-if="item.lang == lang && titlegroup.hasOwnProperty('subtitle')" class="topbar_subtitle">
                    <component :is="'jo' + item2.name" v-for="item2 in item.data" v-bind:key="item2.index" v-bind:data="item2.data"></component>
                  </h2>
                    <div>
                      <ul class="jom-author-items">
                        <li class="jom-author-item theme-font" v-for="(item, index) in contributes" :key="index">
                          <el-popover
                            placement="bottom"
                            popper-class="popover theme-border"
                            v-model="showPopArray[index]"
                            transition="none"
                            trigger="click"
                            width="calc(100% - 10px)">
                            <ul class="popoverUl" :data="authorDetail">
                              <li v-if="authorDetail.orcid && authorDetail.orcid != ''">
                                <label>ORCID：</label><a :href="authorDetail.orcid" target="_blank">{{authorDetail.orcid}}</a>
                              </li>
                              <li v-if="authorDetail.mechanism && authorDetail.mechanism.length>0">
                                <label>{{lang == 'zh' ? '机 构：' : 'Affiliation：'}}</label>
                                <span
                                  v-if="authorDetail.mechanism.length - 1 === 0">{{authorDetail.mechanism[0].text}}</span>
                                <span v-else v-for="(item,index) in authorDetail.mechanism" :key="index"
                                      style="display:block;">
                                                {{item.label ? `${item.label}. ${item.text}` : item.text}}
                                            </span>
                              </li>
                              <li v-if="authorDetail.role" v-for="role in authorDetail.role">
                                <label>{{lang == 'zh' ? '角 色：' : 'Role：'}}</label><span>{{role}}</span>
                              </li>
                              <li v-if="authorDetail.phone">
                                <label>{{lang == 'zh' ? '电 话：' : 'Telephone：'}}</label><span>{{ authorDetail.phone
                                }}</span>
                              </li>
                              <li v-if="authorDetail.email">
                                <label>{{lang == 'zh' ? '邮 箱：' : 'Email：'}}</label><a :style="{'color':ARTICLE.theme}"
                                :href="'mailto:'+authorDetail.email">{{ authorDetail.email }}</a>
                              </li>
                              <li v-if="authorDetail.bioIntro && authorDetail.bioIntro.data.length>0">
                                <div><label>{{lang == 'zh' ? '作者简介：' : 'Profile：'}}</label>
                                  <p><img v-for="item in authorDetail.bioIntro.graphic" :src="item.big" v-if="item.big && item.big != ''"
                                          v-bind:style="{ 'width': '100px','height':'auto'}"/></p>
                                  <p><span v-for="(item,index1) in authorDetail.bioIntro.data" :key="'bio'+index + index1">
                                    <component :is="'jo' + item2.name" v-for="item2 in item" v-bind:key="item2.index" v-bind:data="item2.data"></component>&nbsp;</span></p></div>
                              </li>
                              <li v-else-if="authorDetail.firstIntro">
                                <label>{{lang == 'zh' ? '作者简介：' : 'Profile：'}}</label><span
                                v-text="authorDetail.firstIntro"></span>
                              </li>
                              <li v-else-if="authorDetail.briefIntro">
                                <label>{{lang == 'zh' ? '作者简介：' : 'Profile：'}}</label><span
                                v-text="authorDetail.briefIntro"></span>
                              </li>
                              <li v-else-if="authorDetail.supervisorIntro">
                                <label>{{lang == 'zh' ? '导师简介：' : 'Tutor：'}}</label><span
                                v-text="authorDetail.supervisorIntro"></span>
                              </li>
                              <li v-if="!authorDetail.haveInfo">
                                <span>{{lang == 'zh' ? '暂无本作者相关信息' : 'no detail information about the author'}}</span>
                              </li>
                              <i class="el-icon-close" @click="closePopover(index)"></i>
                            </ul>
                            <span class="author" slot="reference" @click="showAuthorDetail(index)" @blur="currentPopover = -1">
                              <span v-for="item2 in item.name" v-if="item2.lang == lang">
                                  <span :class="{'deceased' : item.deceased}">{{item2.namestyle == 'western' ?
                                  (item2.givenname ? item2.givenname : '') + ' ' + item2.surname : item2.surname + (item2.lang == 'en' ||
                                    /^[a-zA-Z. ]+$/.test(item2.surname)&&/^[a-zA-Z. ]+$/.test(item2.givenname)? ' ' : '') + (item2.givenname ? item2.givenname : '')}}</span>
                                <sup
                                  v-if="contribgroup.aff.length>1" v-for="(aff,index) in item.aff"
                                  :key="index">{{index === item.aff.length - 1 ? aff.text : aff.text + ','}}</sup>
                              <span v-if="item.supRole && item.supRole != ''" style="font-style: italic">({{item.supRole}})</span></span>
                              <span v-if="(item.name.length < 1 || item.name.length == 1 && item.name[0].lang != lang)&& item2.lang == lang"
                                    v-for="item2 in item.stringName">{{item2.surname}}<sup
                                v-if="contribgroup.aff.length>1" v-for="(aff,index) in item.aff"
                                :key="index">{{index === item.aff.length - 1 ? aff.text : aff.text + ','}}</sup>
                              <span v-if="item.supRole && item.supRole != ''" style="font-style: italic">({{item.supRole}})</span></span>
                              <!--<sup v-for="aff in item.aff" :key="aff.text">{{ aff.text }}</sup>-->
                              <a v-if="item.orcid && item.orcid != ''" class="jo-orcid" :href="item.orcid" target="_blank"><img
                              class="orcidImg" style="width: 14px" :src="orcidImgUrl"/></a>
                              <a v-for="item2 in item.name" v-if="item2.lang == lang" href="javascript:void(0);" v-on:click="sendEmail(item.email)" class="jom-email theme-color"><span
                                class="emailImg"
                                v-if="item.corresp && item.corresp.length>0 || item.role.indexOf('corresp')> -1 || item.email">✉</span></a>
                            </span>
                          </el-popover>
                          <span v-for="item1 in item.collab" v-if="item1.lang == lang">{{item1.name}}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="affs" v-if="contribgroup.aff.length > 0">

                      <span class="mechanism" v-for="(item,index) in contribgroup.aff" :key="index" v-if="contribgroup.aff.length > 1">
                        <span v-for="item2 in item.intro" v-if="item2.lang == lang">
                          {{index === contribgroup.aff.length - 1 ? item2.label ? `${item2.label}. ${item2.text}` : item2.text : item2.label ? `${item2.label}. ${item2.text}；` : `${item2.text}；`}}
                        </span>
                      </span>
                      <span class="mechanism" v-if="contribgroup.aff.length == 1">
                        <span v-for="item2 in contribgroup.aff[0].intro" v-if="item2.lang == lang">
                          {{item2.text}}
                        </span>
                      </span>
                    </div>
                  <div class="publish-info" v-if="ARTICLE.originalSource && ARTICLE.originalSource.length > 0">
                    <p v-for="(item,index) in ARTICLE.originalSource">
                      <span class="jom-leading">{{item.lang == 'zh' ? '原文出处：' : 'Original Source：'}}</span>
                      <component v-for="item1 in item.text" :is="'jo' + item1.name" v-bind:key="index"
                                 v-bind:data="item1.data"></component>
                    </p>
                  </div>
                    <div class="publish-info">
                        <p v-if="articlemeta.clc && articlemeta.clc.length>0">
                            <span class="jom-leading">{{lang == 'zh' ? '中图分类号：' : 'CLC：'}}</span>
                          <span v-for="(clc,index) in this.articlemeta.clc">
                            <component v-for="item in clc" :is="'jo' + item.name" v-bind:key="item.index"
                                       v-bind:data="item.data"></component>{{index < articlemeta.clc.length-1 ? '；' : ''}}
                          </span>
                        </p>
                        <p v-if="this.articlemeta.history.opub">
                            <span class="jom-leading">{{lang == 'zh' ? '最近更新：' : 'Updated：'}}</span>{{ this.articlemeta.history.opub }}</p>
                        <p v-if="this.articlemeta.doi"><span class="jom-leading">DOI：</span>
                          <a v-if="showLink"
                          :href="articlemeta.doi.indexOf('http')>-1 || articlemeta.doi.indexOf('https')>-1 ? articlemeta.doi : 'http://dx.doi.org/'+articlemeta.doi"
                          target="_blank">{{ this.articlemeta.doi }}</a>
                          <span v-else>{{ this.articlemeta.doi }}</span>
                        </p>
                    </div>
                    <div class="changeLanguage">
                        <span class="jom-en-btn theme-background" v-if="titlegroup.articletitle.length > 1 || ARTICLE.abstracts.length>1 || ARTICLE.keyword.length>1"
                              @click="changeLang()">{{this.lang === 'zh' ? 'EN' : 'CN'}}</span>
                      <span :style="{'background-color':ARTICLE.theme,'margin-left': '18px'}" :class="{'jom-copy-btn':true,'jom-en-copy':ARTICLE.defaultlang == 'en'}"  v-clipboard:copy="quoteMessage" v-if="quoteMessage && quoteMessage!==''"
                            v-clipboard:success="onCopy">{{ARTICLE.defaultlang === 'zh' ? '引' : 'CITE'}}</span>
                    </div>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>

/* eslint-disable */
import clipboard from '../common/clipboard.vue'
import joinlineformula from '../maincontent/body/formula/inlineformula.vue'
export default {
    components:{
        clipboard,
      joinlineformula
    },
    data() {
        return {
//            bioWidth: 10,
            lang: this.ARTICLE.defaultlang !=='' ? this.ARTICLE.defaultlang : 'zh',
            titlegroup: this.ARTICLE.titlegroup,
            contribgroup: this.ARTICLE.contribgroup,
            contributes: this.ARTICLE.contribgroup.author,
            articlemeta: this.ARTICLE.articlemeta,
            currentActive: 'maincontent',
            authorDetail: {},
            currentPopover: -1,
            emailImgUrl: require('../../assets/img/email.png'),
            orcidImgUrl: require('../../assets/img/orcid.logo.icon.svg'),
            showPopArray: [],
            languageImg: {
                chUrl: require('../../assets/img/icon-cn.png'),
                enUrl: require('../../assets/img/icon-en.png'),
                quoteUrl: require('../../assets/img/icon-quote.png')
            },
            quoteMessage: '', //引文信息
        };
    },
  created() {
    //根据默认语言设置初始页面语言
    this.$bus.emit('currentLang', this.ARTICLE.defaultlang);
    /*if (this.contribgroup.translator && this.contribgroup.translator.length > 0) {
      for (let i = 0; i < this.contribgroup.translator.length; i++) {
        this.contribgroup.translator[i].role.push("trans")
      }
      this.contributes = this.contributes.concat(this.contribgroup.translator);
    }
    if (this.contribgroup.reviewer && this.contribgroup.reviewer.length > 0) {
      for (let i = 0; i < this.contribgroup.reviewer.length; i++) {
        this.contribgroup.reviewer[i].role.push("reviewer")
      }
      this.contributes = this.contributes.concat(this.contribgroup.reviewer);
    }*/
  },
  mounted() {
    this.GLOBAL.topbarheight = this.$refs.topbarheight.offsetHeight;
    if (this.ARTICLE.articlemeta.citeme.length > 0) {
      this.quoteMessage = this.ARTICLE.articlemeta.citeme.reduce((previous, current) => {
        if(previous===null && current===null ) return;
        return `${previous.text}\r\n${current.text}`;
      });
    }

  },
  methods: {
    changeLang() {
      if (this.lang == "zh") {
        this.lang = "en";
        this.$bus.emit('currentLang', "en");
      } else if(this.lang == "en") {
        this.lang = "zh";
        this.$bus.emit('currentLang', "zh");
      }
      this.$nextTick(() => {
        MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
      });
    },
    showName(item){
      for(let i in item.name){
        if (item.name[i].lang === this.lang){
          return true
        }
      }
      return item.stringName && item.stringName !== '' && this.lang === 'zh';
    },
    showAuthorDetail(index) {
      this.currentPopover = index;
      var currentAuthor = this.contributes[index];  //当前作者
      var affList = this.contribgroup.aff;     //机构列表
      let authorDetailData = {
        haveInfo :false,
        mechanism: [],
        email: '',
        orcid: '',
        role: [],
        phone: '',
        briefIntro: '',
        firstIntro: '',
        supervisorIntro: '',
        bioIntro: {
          data: [],
          graphic: []
        }
      };
      // 机构列表
      let authorAffIds = [];
      currentAuthor.aff.forEach(element => {
        authorAffIds.push(element.rid);
      });
      if (currentAuthor.orcid && currentAuthor.orcid !== ''){
        authorDetailData.orcid = currentAuthor.orcid
      }

      for (var i in authorAffIds) {
        for (var j in affList) {
          if (authorAffIds[i] == affList[j].id) {
            let tempAff = {};
            for (var k in affList[j].intro){
              if(affList[j].intro[k].lang == this.lang){
                tempAff.label = affList[j].intro[k].label
                tempAff.text = affList[j].intro[k].text
              }
            }
            if(tempAff!= ''){
              authorDetailData.mechanism.push(
                tempAff
              );
              if(!authorDetailData.haveInfo){
                authorDetailData.haveInfo = true;
              }
            }
          }
        }
      }

      // 邮箱
      authorDetailData.email = currentAuthor.email || '';
      authorDetailData.phone = currentAuthor.phone || '';

      if(authorDetailData.email!=''||authorDetailData.phone!=''){
        if(!authorDetailData.haveInfo){
          authorDetailData.haveInfo = true;
        }
      }
      // 第一作者简介
      if (currentAuthor.first || currentAuthor.role.indexOf('first-author') > -1) {
        if (currentAuthor.first) {
          for (var i in currentAuthor.first) {
            if (currentAuthor.first[i].lang == this.lang) {
              authorDetailData.firstIntro = currentAuthor.first[i].text;
            }
          }
        }
        // 角色
        authorDetailData.role.push(this.lang == 'zh' ? '第一作者' : 'First author');
        authorDetailData.haveInfo = true;
      }
      // 通讯作者简介
      if (currentAuthor.corresp || currentAuthor.role.indexOf('corresp') > -1) {
        if (currentAuthor.corresp) {
          for (var i in currentAuthor.corresp) {
            if (currentAuthor.corresp[i].lang == this.lang) {
              authorDetailData.briefIntro = currentAuthor.corresp[i].text;
            }
          }
        }
        authorDetailData.role.push(this.lang == 'zh' ? '通信作者' : 'Corresponding author');
        authorDetailData.haveInfo = true;
      }
      if (currentAuthor.role && currentAuthor.role.indexOf('equal') > -1) {
        authorDetailData.role.push(this.lang == 'zh' ? '同等贡献者' : 'Contribute equally');
      }

      if (currentAuthor.role && currentAuthor.role.indexOf('trans') > -1) {
        authorDetailData.role.push(this.lang == 'zh' ? '翻译' : 'Translator');
        authorDetailData.haveInfo = true;
      }
      if (currentAuthor.role && currentAuthor.role.indexOf('reviewer') > -1) {
        authorDetailData.role.push(this.lang == 'zh' ? '校对' : 'Reviewer');
        authorDetailData.haveInfo = true;
      }
      // 作者简介
      if (currentAuthor.note) {
        if (authorDetailData.briefIntro == '') {
          for (var i in currentAuthor.note) {
            if (currentAuthor.note[i].lang == this.lang && currentAuthor.note[i].text && currentAuthor.note[i].text!=='') {
              authorDetailData.briefIntro = currentAuthor.note[i].text
              if (!authorDetailData.haveInfo) {
                authorDetailData.haveInfo = true;
              }
            }
          }
        }
      }
      //导师简介
      if (currentAuthor.supervisor) {
        for(var i in currentAuthor.supervisor){
          if(currentAuthor.supervisor[i].lang == this.lang){
            authorDetailData.supervisorIntro = currentAuthor.supervisor[i].text;
            if(!authorDetailData.haveInfo){
              authorDetailData.haveInfo = true;
            }
          }
        }
      }
      //bio简介 带图片的作者简介
      if(currentAuthor.bio){
        for(var i in currentAuthor.bio){
          if(currentAuthor.bio[i].lang == this.lang){
            authorDetailData.bioIntro.data = currentAuthor.bio[i].data
            if (currentAuthor.bio[i].graphic){
              authorDetailData.bioIntro.graphic = currentAuthor.bio[i].graphic
//              this.bioWidth = authorDetailData.bioIntro.graphic.width * this.GLOBAL.deviceDPI.x / 25.4;
            }
            if(!authorDetailData.haveInfo){
              authorDetailData.haveInfo = true;
            }
          }
        }
      }
      this.authorDetail = authorDetailData;
    },
    closePopover(index) {
      this.showPopArray.splice(index, 1, false);
    },
    onCopy: function () {
      this.$message.closeAll();
      this.$message({
        message: '引文信息已复制，您可以直接黏贴',
        type: 'success'
      });
    },
    sendEmail(url){
      if(url){
        window.location.href = 'mailto:' + url;
      }else{
        this.$message.closeAll();
        this.$message({
          showClose: true,
          message: 'sorry，该通讯作者居然没有留下通讯邮箱~',
        });
      }
    },
    copyQuote: function (e) {
//      引文复制UC浏览器特殊处理
      var sUserAgent = navigator.userAgent;
      if (sUserAgent.indexOf('Linux') > -1 && e.text.replace(/\s*/g, "") === this.quoteMessage.replace(/\s*/g, "") && e.action == 'copy') {
        this.$message({
          message: '引文信息已复制，您可以直接黏贴',
          type: 'success'
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.active {
    color: rgb(0, 162, 175);
}
.activeAuthor {
    background-color: #007972 !important;
    color: #fff !important;
}
.jom-topbar {
    /*border-bottom: 1px solid #c3caca;*/
    width: 100%;
    z-index: 100;
    /*background-color: #f0f3f3;*/
    background-color: #fff;
    padding: 30px 10px 20px 10px;
    box-sizing: border-box;
    .el-main {
        padding: 0;
        position: relative;
        .topbar_title {
            line-height: 2.8rem;
          font-size: 2.2rem;
        }
        .topbar_subtitle {
            font-size: 2rem;
            color: #666;
            font-weight: 400;
            margin-top: 10px;
            margin-bottom: 10px;
            line-height: 26px;
            background: none;
        }
        .affs {
            font-size: 1.2rem;
            line-height: 25px;
            color: #666;
            span.mechanism{
                display: block
            }
        }
        .publish-info {
          max-width: 100%;
            margin-top: 0.8rem;
            line-height: 25px;
            color: #666;
            & > p {
                /*height: 25px;*/
                margin-right: 28px;
                margin-top: 5px;
                font-size: 1.2rem;
                .jom-leading {
                    color: #999;
                    margin-right: 5px;
                }
            }
        }
        .changeLanguage {
            text-align: right;
            .jom-copy-btn,.jom-en-btn{
              width: 30px;
              height: 20px;
              display: inline-block;
              text-align: center;
              line-height: 20px;
              text-transform: uppercase;
              border-radius: 3px;
              color: #fff;
              font-size: 14px;
              background: #00a2af;
              cursor: pointer;
              -webkit-transition-duration: 0.3s;
              transition-duration: 0.3s;
              -webkit-transition-property: all;
              transition-property: all;
            }
        }

    }
    .tabs {
        line-height: 60px;
        & > ul {
            overflow: hidden;
            .tabs-item {
                cursor: pointer;
                float: right;
                font-size: 14px;
                margin-left: 26px;
                display: flex;
                align-items: center;
                justify-content: center;
                list-style-type: none;
                img {
                    margin-right: 10px;
                }
                .el-icon-arrow-down {
                    color: #6bb5bf;
                    font-weight: bold;
                    margin-left: 6px;
                    margin-top: 2px;
                }
            }
        }

    }

}

.jom-author-items {
    padding: 0;
    margin: 0;
    font-size: 1.8rem;
    line-height: 2rem;
}

.jom-author-item {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    margin-right: 12px;
    color: #00a2b1;
    list-style-type: none;
    padding: 0 5px;
    text-align: center;
    border-radius: 4px;
    outline: none;
    &:hover {
        /*background-color: #cccccc;*/
    }
    .author {
        cursor: pointer;
    }
    sup {
        line-height: 0;
        font-size:0.8em;
    }
  .deceased {
    border: 1px solid #000000;
  }
  .el-popover.popover{
    left: 10px!important;
  }
}
.popoverUl {
    font-size: 1.4rem;
    /*color: white;*/
    text-align: left;
    word-wrap: break-word;
    word-break: normal;
    & > li {
        line-height: 20px;
        label {
          white-space : nowrap;
            font-weight: bold;
        }
      p{
        font-size: 12px;
      }
    }
    .el-icon-close {
      position: absolute;
      top: 0;
      right: 0;
      padding: 3px 3px 0 3px;
      cursor: pointer;
      border-radius: 5px;
      &:hover {
        color: #00a2b1;
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/componentsMobile/topbar/topbar.vue